<template>
  <div>
    <div v-if="!payment">
      <v-text-field
        v-model="paymentId"
        label="ID do pagamento"
        outlined
        prefix="#"
        class="mt-1"
        :rules="[(v) => v.length >= 8 || 'ID do pagamento inválido']"
      />
      <v-alert v-if="error" type="error" class="mt-2">
        {{ error }}
      </v-alert>
      <div class="d-flex justify-space-between">
        <v-btn @click="$emit('close')" :disabled="loading">Cancelar</v-btn>
        <v-btn
          @click="getPayment"
          :loading="loading"
          :disabled="!paymentId || paymentId.length < 8"
          color="primary"
        >
          Buscar
        </v-btn>
      </div>
    </div>
    <div v-else>
      <v-card class="d-flex gap-2 align-center pa-3 rounded-lg" outlined>
        <div>
          <v-img
            v-if="party"
            :src="party.cover"
            :alt="party.name"
            :aspect-ratio="16 / 9"
            class="rounded-lg"
            height="70"
            :width="70 * (16 / 9)"
          />
        </div>
        <div>
          <p class="text-overline mb-0 lh-1">{{ party?.date | date }}</p>
          <h6 class="mb-0">{{ party?.name }}</h6>
        </div>
      </v-card>

      <v-card outlined class="d-flex flex-wrap pa-3 rounded-lg gap-2 mt-2">
        <base-avatar
          :src="payer?.photo || ''"
          :seed="payer?.id || ''"
          :size="40"
        />
        <div>
          <b class="mb-0">{{ payer?.name }}</b>
          <p class="mb-0 lh-1">{{ payer?.phone }} • {{ payer?.email }}</p>
        </div>
      </v-card>

      <v-card
        outlined
        class="d-flex flex-wrap justify-space-around gap-y-2 pa-2 rounded-lg mt-2"
      >
        <div class="text-center d-flex flex-column align-center px-4">
          <h6 class="mb-0">
            {{ (payment?.amount + payment?.installmentsFee) | currency }}
          </h6>
          <span class="text-caption">Valor do pagamento</span>
        </div>
        <div class="text-center d-flex flex-column align-center px-4">
          <h6 class="mb-0">
            {{ payment?.clientFee | currency }}
          </h6>
          <span class="text-caption">Taxa do cliente</span>
        </div>
        <div
          v-if="payment?.installmentsFee"
          class="text-center d-flex flex-column align-center px-4"
        >
          <h6 class="mb-0">
            {{ payment.installmentsFee | currency }}
          </h6>
          <span class="text-caption">Taxa de parcelamento</span>
        </div>

        <div class="text-center d-flex flex-column align-center px-4">
          <h6 class="mb-0">
            {{ paymentTypes[payment.paymentType]?.text || payment.paymentType }}
          </h6>
          <span class="text-caption">Forma de pagamento</span>
        </div>
        <div class="text-center d-flex flex-column align-center px-4">
          <h6 class="mb-0">
            {{
              paymentMethods[payment.paymentMethod]?.text ||
              payment.paymentMethod
            }}
          </h6>
          <span class="text-caption">Método de pagamento</span>
        </div>
        <div class="text-center d-flex flex-column align-center px-4">
          <h6 class="mb-0">
            {{ payment.Ticket.length }}
          </h6>
          <span class="text-caption"
            >Ingresso{{ payment.Ticket.length > 1 ? "s" : "" }}</span
          >
        </div>
        <div class="text-center d-flex flex-column align-center px-4">
          <v-chip
            label
            class="mb-0"
            :color="paymentStatus[payment.status]?.color || 'gray'"
            small
          >
            {{ paymentStatus[payment.status]?.text || payment.status }}
          </v-chip>
          <span class="text-caption">Status</span>
        </div>
      </v-card>

      <h6 class="text-center mt-4">Selecionar pagamento?</h6>
      <div class="d-flex justify-space-between">
        <v-btn @click="clearPayment" :disabled="loading" color="error">
          Não
        </v-btn>
        <v-btn
          @click="localizePayment"
          :loading="loading"
          :disabled="!paymentId || paymentId.length < 8"
          color="primary"
        >
          Sim
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import FINANCIAL from "@/services/admin/financial";
import PAYMENT from "@/utils/payment";
export default {
  data: () => ({
    paymentId: "",
    payment: null,
    loading: false,
    error: null,
    paymentTypes: PAYMENT.paymentType,
    paymentMethods: PAYMENT.paymentMethod,
    paymentStatus: PAYMENT.ticketStatus,
  }),
  methods: {
    async getPayment() {
      try {
        this.loading = true;
        this.error = null;
        const data = await FINANCIAL.getPayment(this.paymentId);
        this.payment = data.payment;
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    clearPayment() {
      this.payment = null;
      this.paymentId = "";
      this.error = null;
    },
    localizePayment() {
      this.$emit("payment", this.payment);
      this.clearPayment();
    },
  },
  computed: {
    payer() {
      const [ticket] = this.payment?.Ticket || [];
      if (!ticket) return null;
      return this.payment?.Payer || ticket.Owner;
    },
    party() {
      const [ticket] = this.payment?.Ticket || [];
      if (!ticket) return null;
      return ticket.TicketBlock.TicketGroup.Party;
    },
  },
};
</script>
